{
    "account": "Account",
    "add_bookmark": "Aggiungi ai segnalibri",
    "add_date": "Aggiungi una data",
    "ago": "{{duration}} fa",
    "api_key": "Chiave API",
    "are_you_sure": "Sei sicuro/sicura?",
    "ask_delete_message": "Eliminare questo messaggio?",
    "audio_not_ready": "L'audio non è ancora pronto.",
    "bookmark_added": "Messaggio aggiunto ai segnalibri.",
    "bookmark_removed": "Messaggio rimosso dai segnalibri.",
    "bookmarks": "segnalibri",
    "cancel": "Annulla",
    "cancel_write": "Vuoi davvero cancellare la scrittura di un nuovo messaggio?",
    "changed_group_name": "ha cambiato il nome del gruppo",
    "confirm_password_placeholder": "conferma la password",
    "connect": "Connessione",
    "create_a_group": "Crea un gruppo",
    "create_the_group": "Crea il gruppo",
    "daily": "Ogni giorno",
    "default_group": "Gruppo predefinito",
    "delete": "Elimina",
    "destroy_account": "Elimina il tuo account",
    "destroy_account_explain": "Una volta il proprio account eliminato, non è più possibile tornare indietro. Sii certo/certa.",
    "edit": "Modifica",
    "email": "E-mail",
    "email_input": "Inserisci il tuo indirizzo e-mail qui",
    "empty_message": "Il messaggio è vuoto e non può essere inviato.",
    "error_new_message": "Si è verificato un errore durante l'invio del messaggio.",
    "error": "Si è verificato un errore",
    "error_upload": "Si è verificato un errore durante il caricamento",
    "forgot_password": "Hai dimenticato la password?",
    "group_left": "Hai lasciato il gruppo.",
    "groups": "Gruppi",
    "group_share_choice": "A quale gruppo vuoi inviare questo messaggio?",
    "group_updated": "Il gruppo è stato aggiornato.",
    "has_commented_on": "ha commentato su",
    "has_joined": "si è unito/a a",
    "has_left": "ha lasciato",
    "has_posted_in": "ha pubblicato in",
    "hourly": "Ogni ora",
    "in": "in",
    "Invalid login/password": "Nome utente o password non validi",
    "invitation_link": "Collegamento di invito",
    "invitation_welcome": "Benvenuto o benvenuta su Zusam. Iscriviti prima di entrare nel gruppo.",
    "just_now": "Proprio ora",
    "lang": "lingua",
    "login": "Accedi",
    "login_input": "Scegli un identificatore",
    "login_placeholder": "e-mail",
    "logout": "Esci",
    "mark_all_as_read": "contrassegna tutto come letto",
    "monthly": "Ogni mese",
    "multiple_photos_upload": "Si è verificato un errore. Prova a caricare le immagini una alla volta (questo può accadere in alcuni browser)",
    "name_input": "Scegli un nome",
    "name": "Nome",
    "new_password_placeholder": "nuova password",
    "next_coms": "Vedi i prossimi commenti",
    "none": "Nessuna",
    "notification_emails": "Notifiche per posta elettronica",
    "notification_emails_stopped": "Notifiche per posta elettronica interrotte!",
    "notifications": "notifiche",
    "parent_message": "Messaggio originale",
    "password_input": "Scrivi qui una nuova password",
    "password": "Password",
    "password_placeholder": "password",
    "password_reset_mail_sent": "Cerca l'e-mail di ripristino della password nella tua casella di posta.",
    "passwords_dont_match": "Le password non corrispondono",
    "previous_coms": "Vedi i commenti precedenti",
    "public_link": "collegamento pubblico",
    "publish_in_group": "pubblica nel gruppo",
    "quit_group": "Lascia il gruppo",
    "remove_bookmark": "Rimuovi dai segnalibri",
    "replies_one": "{{count}} risposta",
    "replies_other": "{{count}} risposte",
    "reply": "rispondi",
    "reset_api_key": "Reimposta la chiave API (sarai disconnesso/disconnessa)",
    "reset_invitation_link": "Ripristina il collegamento di invito",
    "reset_password_title": "Ripristina la tua password",
    "save_changes": "Salva le modifiche",
    "search_in_group": "ricerca in questo gruppo",
    "search_without_result": "La tua ricerca non corrispondeva a nessun messaggio.",
    "settings": "Impostazioni",
    "settings_updated": "Le impostazioni sono state aggiornate",
    "share_message": "condividi il messaggio",
    "signup": "Iscriviti",
    "submit": "Invia",
    "text_placeholder": "Scrivi qui il tuo messaggio",
    "the_message_from": "il messaggio da",
    "title_placeholder": "Titolo del messaggio (opzionale)",
    "to": "in",
    "upload_audio": "Aggiungi un file audio.",
    "upload_image": "Aggiungi foto",
    "upload_music": "Aggiungi musica",
    "upload_pdf": "Aggiungi PDF",
    "upload_video": "Aggiungi un video",
    "User not found": "Utente non trovato",
    "users": "utenti",
    "video_not_ready": "Il video non è ancora pronto.",
    "weekly": "Ogni settimana"
}
